import SalesPageStore from './SalesPageStore';

export default SalesPageStore;
